import * as React from "react";
import { Box, Container, Paper } from "@mui/material";
import { marketingColors } from "../../../app/components/tickitMarketingTheme";
import { getBrandingColors } from "../brandingUtils";
import EventDetailsStrip from "../EventDetailsStrip";
import RegistrationBrandingHeader from "../RegistrationBrandingHeader";
import RegistrationForm from "../RegistrationForm";
import RegistrationPageFooter from "../RegistrationPageFooter";
import { cardSx, layout } from "../templateLayout";

export default function MinimalTemplate({ page, event, user, onSubmit, submitting }) {
  const branding = page?.branding || {};
  const { primary, accent } = getBrandingColors(branding);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(180deg, ${primary}18 0%, ${marketingColors.gray50} 45%)`,
        py: layout.pagePy,
        px: layout.pagePx,
      }}
    >
      <Container maxWidth="md" disableGutters>
        <Paper elevation={0} sx={cardSx(branding)}>
          <Box
            sx={{
              px: layout.cardPadding,
              py: { xs: 3, sm: 3.5 },
              textAlign: "center",
              bgcolor: primary,
              color: "#fff",
            }}
          >
            <RegistrationBrandingHeader branding={branding} event={event} variant="light" />
          </Box>
          <Box
            sx={{
              px: layout.cardPadding,
              py: { xs: 2, sm: 2.5 },
              borderBottom: `1px solid ${accent}33`,
              bgcolor: "#fff",
            }}
          >
            <EventDetailsStrip event={event} branding={branding} primaryColor={primary} dense />
          </Box>
          <Box sx={{ px: layout.cardPadding, py: layout.cardPadding, bgcolor: "#fff" }}>
            <RegistrationForm
              event={event}
              user={user}
              branding={branding}
              onSubmit={onSubmit}
              submitting={submitting}
              embedded
            />
          </Box>
        </Paper>
        <RegistrationPageFooter branding={branding} />
      </Container>
    </Box>
  );
}
